import { CirculationModel } from './CirculationModel';
import { ClientModel } from './ClientModel';
import { CountryModel } from './CountryModel';
import { EditorialCategoryModel } from './EditorialCategoryModel';
import { MediaModel } from './MediaModel';
import { StateModel } from './StateModel';
import { CostCentimeterModel } from './CostCentimeterModel';
import { CostTimeModel } from './CostTimeModel';
import { LocationModel } from './LocationModel';
import { ExpositionModel } from './ExpositionModel';
import { PeriodModel } from './PeriodModel';
import { CoverPresenceModel } from './CoverPresenceModel';
import { EditAction } from '../shared/enum/EditAction';
import { VehicleIpmModel } from './VehicleIpmModel';

export interface VehicleModel {
    id: number,
    codeMetric: number | null,
    name: string,
    nomenclature: string | null,
    media: MediaModel | null,
    circulation: CirculationModel | null,
    identification: string,
    country: CountryModel | null,
    countryId: number | null,
    state: StateModel | null,
    stateId: number | null,
    cityName: string,
    editorialCategory: EditorialCategoryModel | null,
    advertisingCost: number | null,
    clients: ClientModel[],

    broadcasterName?: string,
    broadcasterMaskName?: string,
    costTime?: CostTimeModel[],
    costCentimeter?: CostCentimeterModel,
    uploadDate?: Date,
    endOfPeriod?: Date,

    locations?: LocationModel[] | null,
    expositions?: ExpositionModel[] | null,
    period?: PeriodModel[] | null,
    coverPresences?: CoverPresenceModel[],
    ipmList: VehicleIpmModel[] | null,

    editAction: EditAction
}

export const vehicleModelInitial: VehicleModel = {
    id: 0,
    codeMetric: null,
    name: '',
    nomenclature: null,
    media: null,
    circulation: null,
    identification: '',
    country: null,
    countryId: null,
    state: null,
    stateId: null,
    cityName: '',
    editorialCategory: null,
    advertisingCost: null,
    clients: [],
    ipmList: [],
    editAction: EditAction.NONE,
};
